import { TrackingDetails } from '../../../TrackingDetails';

export const PreprintedTrackingDetails = ({
  shipment,
  hasMultipleShipments,
}) => {
  return (
    <TrackingDetails
      type="preprinted"
      shipment={shipment}
      hasMultipleShipments={hasMultipleShipments}
      shouldShowProgressIndicator
    />
  );
};
